import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ProductDetail from '@/store/entities/ProductDetailExpandDto'
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';


interface FrontDistributionState extends ListState<any> {
    model: ProductDetail,
}

class FrontDistributionimports extends ListModule<FrontDistributionState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 50,
        list: new Array<any>(),
        model: null,
        loading: false,
        pageSizeOpts: [50, 100, 150, 200]

    }
    actions = {
        async getAll(context: ActionContext<FrontDistributionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontDistributionProduct/GetDistributionProductList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async GetProductDetail(context: ActionContext<FrontDistributionState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontDistributionProduct/GetProductDetail', { params: payload.data });
            let page = reponse.data.result as ProductDetail;
            context.state.model = page;
            return page;
        },
        async GetStoreAddressList(context: ActionContext<FrontDistributionState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/FrontDistributionProduct/GetStoreAddressList', { params: payload.data });
            let page = reponse.data.result
            return page;
        },

    };
    mutations = {
        setCurrentPage(state: FrontDistributionState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: FrontDistributionState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const frontdistributionimport = new FrontDistributionimports();
export default frontdistributionimport;